import React, { useEffect } from 'react';

import { Box, Grid } from '@material-ui/core';

import CustomBreadcrumbs from '../../../components/Bradcrumbs/Breadcrumbs.component';
import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import { useAssistanceDataContext } from '../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../context/sidebar/sidebar.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import AssistanceComments from './Steps/AssistanceComments.component';
import AssistanceSummary from './Steps/AssistanceSummary/AssistanceSummary.component';
import AssistanceType from './Steps/AssistanceType.component';
import AssistanceVehicle from './Steps/AssistanceVehicle.component';
import Documentation from './Steps/Documentation.component';
import HowItHappened from './Steps/HowItHappened.component';
import PassengersAssistance from './Steps/PassengersAssistance.component';
import PhoneContact from './Steps/PhoneContact.components';
import Transfer from './Steps/Transfer.component';
import VehicleUbication from './Steps/VehicleUbication.component';

const Assistance = () => {
  const { user } = useAuthDataContext();
  const {
    loading,
    step,
    setStep: setStepFlow,
    goBack,
    assistance_body,
  } = useAssistanceDataContext();
  const {
    setStepperTitle,
    setStep: setStepSidebar,
    stepperTitle,
  } = useSidebarContext();

  const STEPS = [
    {
      title: 'Pedir una grúa',
      // title: 'Necesito asistencia',
      content: <AssistanceVehicle></AssistanceVehicle>,
    },
    {
      title: 'Tipo de asistencia',
      content: <AssistanceType></AssistanceType>,
    },
    {
      title: assistance_body.assistance_type
        ? assistance_body.assistance_type_title
        : 'Problema reportado',
      content: <HowItHappened></HowItHappened>,
    },
    {
      title: 'Documentación',
      content: <Documentation></Documentation>,
    },
    {
      title: 'Traslado',
      content: <Transfer></Transfer>,
    },
    {
      title: 'Ubicación del vehículo',
      content: <VehicleUbication></VehicleUbication>,
    },
    {
      title: 'Pasajeros',
      content: <PassengersAssistance></PassengersAssistance>,
    },
    {
      title: 'Resumen de la asistencia',
      content: <AssistanceComments></AssistanceComments>,
    },
    {
      title: 'Datos de contacto',
      content: <PhoneContact></PhoneContact>,
    },
    {
      title: 'Resumen de la asistencia',
      content: <AssistanceSummary></AssistanceSummary>,
    },
  ];

  useEffect(() => {
    setStepperTitle(STEPS[step].title);
    setStepSidebar(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    dataLayerPush('Inicio_asistencia', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>
      <StepperSubHeader
        goBack={goBack}
        step={step}
        totalSteps={STEPS.length}
      ></StepperSubHeader>
      <Grid
        container
        justify={step === 3 ? 'flex-end' : 'center'}
        style={{ height: 'calc(100% - 4px)' }}
      >
        <Grid
          item
          xs={11}
          md={step === 3 ? 11 : 9}
          lg={step === 3 ? 11 : 8}
          xl={step === 3 ? 11 : 7}
        >
          <Grid container style={{ height: '100%' }}>
            <CustomBreadcrumbs
              isWorkflow
              setStepFlow={setStepFlow}
              setStepSidebar={setStepSidebar}
              step={step}
              stepperTitle={stepperTitle}
              crumbs={[]}
              setStepperTitle={setStepperTitle}
            ></CustomBreadcrumbs>
            <Grid item xs={12}>
              {STEPS[step].content}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Assistance;
